import type { ReviewFlag, SupervisedCall } from "../types";

const MANUAL_FLAGS_KEY = "supervision.manual_flags";

export function getManualFlags(): ReviewFlag[] {
  try {
    const raw = localStorage.getItem(MANUAL_FLAGS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function getManualFlag(callId: string): ReviewFlag | null {
  if (!callId) return null;
  const flags = getManualFlags();
  return flags.find((f) => f.call_id === callId) || null;
}

export function saveManualFlag(
  callId: string,
  note = "",
  call?: Partial<SupervisedCall>,
  flaggedBy = "supervisor",
  flaggedByName = "Supervisor",
): ReviewFlag {
  const flags = getManualFlags();
  const existingIdx = flags.findIndex((f) => f.call_id === callId);
  const now = new Date().toISOString();

  let updated: ReviewFlag;
  if (existingIdx >= 0) {
    updated = {
      ...flags[existingIdx],
      note,
      note_edited_by: flaggedBy,
      note_edited_at: now,
      call: call ? ({ ...(flags[existingIdx].call || {}), ...call } as SupervisedCall) : flags[existingIdx].call,
    };
    flags[existingIdx] = updated;
  } else {
    updated = {
      call_id: callId,
      flagged_by: flaggedBy,
      flagged_by_name: flaggedByName,
      flagged_at: now,
      note,
      note_edited_by: null,
      note_edited_at: null,
      call: call ? (call as SupervisedCall) : undefined,
    };
    flags.unshift(updated);
  }

  try {
    localStorage.setItem(MANUAL_FLAGS_KEY, JSON.stringify(flags));
  } catch {}

  window.dispatchEvent(new Event("supervision-flags-changed"));
  return updated;
}

export function removeManualFlag(callId: string): void {
  const flags = getManualFlags().filter((f) => f.call_id !== callId);
  try {
    localStorage.setItem(MANUAL_FLAGS_KEY, JSON.stringify(flags));
  } catch {}
  window.dispatchEvent(new Event("supervision-flags-changed"));
}

